export enum TimepickerInputSize {
	Auto = 'auto',
	Small = 'small',
	Large = 'large',
}
